export default __webpack_public_path__ + "static/media/border-1.0fedfa83.webp";